import { Info } from 'lucide-react';
import type { FinalDecision } from '@/types';

/** FR-077: label describing the activation impact of each final decision */
export function DecisionImpactNote({ decision }: { decision: FinalDecision | null }) {
  if (!decision) return null;
  const notes: Record<FinalDecision, string> = {
    APPROVED: 'This will ACTIVATE the contract and mark it as approved.',
    APPROVED_WITH_ALERTS: 'This will ACTIVATE the contract with alerts noted for follow-up.',
    REJECTED: 'This will REJECT the contract. It can be re-submitted with corrections.',
    ESCALATED: 'This will ESCALATE the contract for senior review.',
  };
  const text = notes[decision];
  if (!text) return null;
  return (
    <p className="text-xs text-muted-foreground flex items-start gap-1 mt-1">
      <Info className="h-3.5 w-3.5 mt-0.5 flex-shrink-0" aria-hidden="true" />
      <span>{text}</span>
    </p>
  );
}
